import React from 'react';
import { Table } from 'antd';
import trans from '../../translations.json';
import dict from '../../dictionary';
import { getTableLabel } from '../anomalies/AnomalyNote';
import { datesOfLTCDeathAnomalies } from '../anomalies/anomaliesList';
import {
  dateFormater,
  percentChangeCalc,
  checkIfLessThanFive,
} from '../utils';
import Icon from '../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

class LTCDailyDeathsTable extends React.Component {
  render() {
    const cData = this.props.data;

    let tableData = cData
      .map((item, z) => {
        var yesterdayResDaily = cData[z - 2]
          ? cData[z - 1][dict.mltc_total_residents_deaths] -
            cData[z - 2][dict.mltc_total_residents_deaths]
          : 0;

        var todayResDaily = cData[z - 1]
          ? item[dict.mltc_total_residents_deaths] -
            cData[z - 1][dict.mltc_total_residents_deaths]
          : 0;

        var yesterdayStaffDaily = cData[z - 2]
          ? cData[z - 1][dict.mltc_total_staff_deaths] -
            cData[z - 2][dict.mltc_total_staff_deaths]
          : 0;

        var todayStaffDaily = cData[z - 1]
          ? item[dict.mltc_total_staff_deaths] -
            cData[z - 1][dict.mltc_total_staff_deaths]
          : 0;

        // if (
        //   cData[z - 2] &&
        //   cData[z - 2][dict.mltc_total_staff_deaths] !== null &&
        //   cData[z - 1][dict.mltc_total_staff_deaths] !== null
        // ) {
        //   let lessThanFive = checkIfLessThanFive([
        //     cData[z - 1][dict.mltc_total_staff_deaths],
        //     cData[z - 2][dict.mltc_total_staff_deaths],
        //   ]);
        //   if (lessThanFive) {
        //     yesterdayStaffDaily = '< 5';
        //   } else {
        //     let difference =
        //       Number(cData[z - 1][dict.mltc_total_staff_deaths]) -
        //       Number(cData[z - 2][dict.mltc_total_staff_deaths]);
        //     difference < 5 && difference !== 0
        //       ? (yesterdayStaffDaily = '< 5')
        //       : (yesterdayStaffDaily = difference);
        //   }
        // } else {
        //   yesterdayStaffDaily = 0;
        // }

        // var todayStaffDaily;

        // if (
        //   cData[z - 2] &&
        //   item[dict.mltc_total_staff_deaths] !== null &&
        //   cData[z - 1][dict.mltc_total_staff_deaths] !== null
        // ) {
        //   let lessThanFive = checkIfLessThanFive([
        //     item[dict.mltc_total_staff_deaths],
        //     cData[z - 1][dict.mltc_total_staff_deaths],
        //   ]);
        //   if (lessThanFive) {
        //     todayStaffDaily = '< 5';
        //   } else {
        //     let difference =
        //       Number(item[dict.mltc_total_staff_deaths]) -
        //       Number(cData[z - 1][dict.mltc_total_staff_deaths]);
        //     difference < 5 && difference !== 0
        //       ? (todayStaffDaily = '< 5')
        //       : (todayStaffDaily = difference);
        //   }
        // } else {
        //   todayStaffDaily = 0;
        // }

        return {
          index: z,
          date: dateFormater(item[dict.reportedDate]),
          newRes: cData[z - 1] && todayResDaily,
          resPercentChange: percentChangeCalc(
            todayResDaily,
            yesterdayResDaily,
            2,
          ),
          newStaff: cData[z - 1] && todayStaffDaily,
          staffPercentChange: percentChangeCalc(
            todayStaffDaily,
            yesterdayStaffDaily,
            2,
          ),
        };
      })
      .reverse();
    tableData.pop();

    const columns = [
      {
        title: trans.date[this.props.lang],
        dataIndex: 'date',
        key: 'date',
        width: '35%',
        render: (date) => (
          <>
            {getTableLabel(
              date,
              datesOfLTCDeathAnomalies,
              this.props.lang,
            )}
          </>
        ),
      },
      {
        title: trans.ltc.ltcResidentDeathsT[this.props.lang],
        dataIndex: 'newRes',
        key: 'newRes',
        width: '15%',
      },
      {
        title: trans.general.precentChange[this.props.lang],
        dataIndex: 'resPercentChange',
        key: 'resPercentChange',
        width: '20%',
        render: (text, record) => {
          if (Number(text) > 0) {
            return (
              <span>
                <img
                  alt={trans.general.increase[this.props.lang]}
                  style={{ transform: 'rotate(180deg)' }}
                  src={Icon}
                />
                {text} %
              </span>
            );
          } else if (Number(text) < 0) {
            return (
              <span>
                <img
                  alt={trans.general.decrease[this.props.lang]}
                  src={Icon}
                />
                {Math.abs(Number(text))} %
              </span>
            );
          } else {
            return <span> ― </span>;
          }
        },
      },
      {
        title: trans.ltc.ltcStaffDeathsT[this.props.lang],
        dataIndex: 'newStaff',
        key: 'newStaff',
        width: '15%',
      },
      {
        title: trans.general.precentChange[this.props.lang],
        dataIndex: 'staffPercentChange',
        key: 'staffPercentChange',
        width: '20%',
        render: (text, record) => {
          if (Number(text) > 0) {
            return (
              <span>
                <img
                  alt={trans.general.increase[this.props.lang]}
                  style={{ transform: 'rotate(180deg)' }}
                  src={Icon}
                />
                {text} %
              </span>
            );
          } else if (Number(text) < 0) {
            return (
              <span>
                <img
                  alt={trans.general.decrease[this.props.lang]}
                  src={Icon}
                />
                {Math.abs(Number(text))} %
              </span>
            );
          } else {
            return <span> ― </span>;
          }
        },
      },
    ];

    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default LTCDailyDeathsTable;
